/**
 * @generated SignedSource<<7de6df8d598920a8c88a514324be30b0>>
 * @relayHash 0060870f63f8c593a683d78f2f26cca5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ebe389852572e1cd6aa57eba21798a9a1ca59cf560780f15d5a782cb342bc4bd

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RecommendedTabEntryPointRootQuery } from './RecommendedTabEntryPointRootQuery.graphql';

import isForYouNewUsersEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraForYouLandAllNewUsersRelayProvider';
import isJiraFyRecommendedAssignAgentEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraFyRecommendedAssignAgentRelayProvider';
import isHexagonSupportEnabled_provider from '@jira/platform__graphql-relay-provider/src/hexagon-support.relayprovider';

const node: PreloadableConcreteRequest<RecommendedTabEntryPointRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ebe389852572e1cd6aa57eba21798a9a1ca59cf560780f15d5a782cb342bc4bd",
    "metadata": {},
    "name": "RecommendedTabEntryPointRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraFyRecommendedAssignAgentRelayProvider": isJiraFyRecommendedAssignAgentEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraForYouLandAllNewUsersRelayProvider": isForYouNewUsersEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider
    }
  }
};

export default node;
